export default __webpack_public_path__ + "static/media/back.b8a79976.svg";